import { Css, Icon, Palette, useTestIds } from "@homebound/beam";
import type { ReactNode } from "react";

export type ConflictIconProps = {
  /** The "Option Conflict" message from `conflictMessage`, shown on hover. Without one nothing is rendered. */
  message: ReactNode | undefined;
};

/**
 * Shows an option conflict when toggling the option would drop other selected options, i.e. the server's
 * `CheckoutConfigPotentialOption.wouldDeselect` is non-empty. Hovering tells which ones.
 */
export function ConflictIcon(props: ConflictIconProps) {
  const { message } = props;
  const tid = useTestIds(props, "conflict");
  if (!message) return null;
  return (
    <span css={Css.fs0.df.$} {...tid}>
      <Icon icon="error" inc={2} color={Palette.Yellow600} tooltip={message} />
    </span>
  );
}
